// src/utils/analytics.js
export const trackEvent = (eventName, params) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag !== "undefined" && typeof window.dataLayer !== "undefined") {
      window.gtag('event', eventName, params);
    } else {
      // Silent fail in development or when GA is not loaded
      if (process.env.NODE_ENV === 'development') {
        console.log('[Analytics]', eventName, params);
      }
    }
  } catch (error) {
    // Silently catch any analytics errors to prevent breaking the app
    console.warn('[Analytics Error]', error);
  }
};
